// extracted by mini-css-extract-plugin
module.exports = {"cImg":"BannerEstatico_cImg__jQg0z","bannerSimple":"BannerEstatico_bannerSimple__C17bZ"};